export const APIURL = {
  login: 'login',
  logout: 'logout',
  resetPassword: 'password/email',
  changePassword: 'password/reset'
};
